import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  browserSessionPersistence,
  setPersistence,
  signInWithPopup,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCgb99Q163zERhf4S2Csyawfmw_92p-_LE",
  authDomain: "afas---myparcel.firebaseapp.com",
  projectId: "afas---myparcel",
  storageBucket: "afas---myparcel.firebasestorage.app",
  messagingSenderId: "384601188824",
  appId: "1:384601188824:web:62cceb3dfc07e937c66aad",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: "login",
  hd: "buurtzorgnederland.com",
  max_auth_age: "0",
});

export {
  auth,
  db,
  provider,
  browserSessionPersistence,
  setPersistence,
  signInWithPopup,
};
